import React from 'react';
import DocTitle from 'react-document-title';
import Login from '../Login';
import Header from '../Header';
import request from 'arcdynamic-request';
import Sidebar from '../Sidebar';

export default class Root extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			user: null,
			isSuper: null,
			isAgent: null,
			showMenu: true,
			userData: null,
		};

		this.setUser = this.setUser.bind(this);
		this.signOut = this.signOut.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
	}

    componentDidMount() {
		request(arc.path.api, {
			service: 'arcimedes',
			action: 'Authentication.getStatus',
		}).then(res => {
			if (res && res.success) {
				this.setUser(res.data);
			} else {
				this.setUser(false);
			}
		})
	}

	handleKeyDown(e) {
		// Scheme to only show the focus outline when the user has used keyboard navigation to focus an element.
		if (e.key === 'Tab') {
			setTimeout(()=>{
				if (this.activeElement !== document.activeElement) {
					if (this.activeElement) {
						this.activeElement.removeAttribute('data-focused');
					}
					if (document.activeElement) {
						this.activeElement = document.activeElement;
						this.activeElement.setAttribute('data-focused', true);
					}
				}
			}, 0);
		}
	}

	setUser(user) {
		if (user) {
			Promise.all([
				request(arc.path.api, {
					service: 'arcimedes',
					action: 'open.dataquery.execute',
					params: ['PERMISSIONS_TEST'],
				}),
                request(arc.path.api, {
                    service: 'arcimedes',
                    action: 'open.User.get',
                    params: ['code', 'USERS', {}],
                }),
			]).then(res => {
				this.setState({
					user,
                    isSuper: res[0].success && res[1].success && res[1].data && res[1].data._ext && res[1].data._ext.USER_TYPE === 'admin',
                    isAgent: res[1].success && res[1].data && res[1].data._ext && res[1].data._ext.USER_TYPE === 'agent',
					userData: res[1].success && res[1].data
				});
			});
		} else {
			this.setState({
				user,
				isSuper: false,
				isAgent: false,
				userData: false,
			});
		}
	}

	signOut() {
		request(arc.path.api, {
			service: 'arcimedes',
			action: 'Authentication.logout',
		});

		this.setState({
			user: false,
			isSuper: false,
            isAgent: false,
            userData: false,
        });
	}

	render() {
		const { user, isSuper, isAgent, userData } = this.state;

		if (user === null) return null;

		return (
			<div className='Root' onKeyDown={this.handleKeyDown}>
				<DocTitle title='STRIVE'/>
				<Header location={this.props.location} isSuper={isSuper} isAgent={isAgent} pathname={this.props.location.pathname}/>
				<Sidebar signOut={user ? this.signOut : null} location={this.props.location} isSuper={isSuper} isAgent={isAgent} pathname={this.props.location.pathname}>
                    {
                        user ? React.cloneElement(this.props.children, {isSuper, isAgent, userData}) : <Login setUser={this.setUser}/>
                    }
				</Sidebar>
			</div>
		);
	}
}